/**
 * Protected Supabase client configuration for self-hosted instance.
 * This file is NOT auto-generated by Lovable and will survive deployments.
 * All imports should reference this file instead of client.ts.
 */
import { createClient } from "@supabase/supabase-js";
import { type Database } from "./types";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "./supabaseConfig";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
